import { SVGProps } from "react";
export const RootFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={0.5} width={40} height={40} rx={4} fill="#3B3B3B" />
    <path
      d="M30.6665 12.5002H19.9998L17.3332 9.8335H9.33317C7.8665 9.8335 6.67984 11.0335 6.67984 12.5002L6.6665 28.5002C6.6665 29.9668 7.8665 31.1668 9.33317 31.1668H30.6665C32.1332 31.1668 33.3332 29.9668 33.3332 28.5002V15.1668C33.3332 13.7002 32.1332 12.5002 30.6665 12.5002ZM25.3332 25.8335H27.9998V23.1668H25.3332V20.5002H27.9998V17.8335H25.3332V15.1668H30.6665V28.5002H25.3332V25.8335ZM25.3332 25.8335H22.6665V28.5002H9.33317V12.5002H16.2265L18.8932 15.1668H22.6665V17.8335H25.3332V20.5002H22.6665V23.1668H25.3332V25.8335Z"
      fill="#DEDEDE"
    />
  </svg>
);

export const Folder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.17 6.00439L11.17 8.00439H20V18.0044H4V6.00439H9.17ZM10 4.00439H4C2.9 4.00439 2.01 4.90439 2.01 6.00439L2 18.0044C2 19.1044 2.9 20.0044 4 20.0044H20C21.1 20.0044 22 19.1044 22 18.0044V8.00439C22 6.90439 21.1 6.00439 20 6.00439H12L10 4.00439Z"
      fill="white"
    />
  </svg>
);

export const Top = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Component 5">
      <path
        id="Vector"
        d="M1.6084 9.21777V9.22589L10.2077 14.2317L1.6084 9.21777ZM10.5898 14.4225C11.0202 14.5971 11.5028 14.6824 11.9935 14.6824V14.6702C11.5028 14.6702 11.0161 14.5849 10.5898 14.4225Z"
        fill="white"
      />
      <path
        id="Vector_2"
        d="M23.0226 5.82796L13.7878 0.444557C12.7662 -0.148186 11.2298 -0.148186 10.2122 0.444557L0.973354 5.82796C0.353947 6.18929 0 6.73738 0 7.33418V16.6679C0 17.2647 0.353947 17.8168 0.973354 18.1781L10.2081 23.5575C10.7029 23.8498 11.3464 24 11.994 24H12.002C12.3399 24 12.6777 23.9594 12.9995 23.8782L13.5465 23.7361C13.5465 23.7361 13.5867 23.7158 13.6028 23.7077C13.6672 23.6752 13.7275 23.6427 13.7878 23.6103L23.0226 18.2268C23.642 17.8696 23.996 17.3174 23.996 16.7166V7.45192C24 7.41132 24 7.37478 24 7.33824C24 6.74144 23.642 6.18929 23.0226 5.82796ZM11.994 22.376C11.6239 22.376 11.2619 22.2989 11.0126 22.1528L1.77778 16.7693C1.67722 16.7125 1.62896 16.6597 1.60885 16.6354V9.2139L10.2081 14.2279H10.2122C10.2765 14.2685 10.3409 14.3009 10.4093 14.3375C10.4696 14.3659 10.5299 14.3903 10.5902 14.4187C11.0166 14.5811 11.5033 14.6663 11.994 14.6663V22.376ZM22.3871 16.6841C22.371 16.7125 22.3188 16.7612 22.2182 16.8221L13.6028 21.8401V14.374C13.6672 14.3456 13.7275 14.3131 13.7878 14.2766L22.3871 9.26668V16.6841Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const FrontLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Component 5">
      <path
        id="Vector"
        d="M23.5226 5.82796L14.2878 0.444557C13.2662 -0.148186 11.7298 -0.148186 10.7122 0.444557L1.47335 5.82796C0.853946 6.18929 0.5 6.73738 0.5 7.33418V16.6679C0.5 17.2647 0.853946 17.8168 1.47335 18.1781L10.7081 23.5575C11.2029 23.8498 11.8464 24 12.494 24H12.502C12.8399 24 13.1777 23.9594 13.4995 23.8782L14.0465 23.7361C14.0666 23.7239 14.0867 23.7158 14.1028 23.7077C14.1672 23.6752 14.2275 23.6427 14.2878 23.6103L23.5226 18.2268C24.142 17.8696 24.496 17.3174 24.496 16.7166V7.45192C24.5 7.41132 24.5 7.37478 24.5 7.33824C24.5 6.74144 24.142 6.18929 23.5226 5.82796ZM13.4834 12.8272C13.4231 12.8637 13.3547 12.8922 13.2863 12.9206C13.2823 12.9206 13.2783 12.9246 13.2743 12.9246C12.7393 13.1236 11.9671 13.0911 11.5166 12.8272L2.27778 7.4438C2.2094 7.4032 2.16516 7.36666 2.137 7.33824H2.14102C2.16918 7.30576 2.21342 7.27328 2.27778 7.23268L11.5166 1.85334C12.0314 1.55291 12.9686 1.55291 13.4834 1.85334L22.7182 7.23268C22.7906 7.27328 22.8348 7.30982 22.863 7.33824C22.8348 7.36666 22.7906 7.4032 22.7182 7.4438L13.4834 12.8272ZM22.8871 16.6841C22.871 16.7125 22.8188 16.7612 22.7182 16.8221L14.1028 21.8401V14.374C14.1672 14.3456 14.2275 14.3131 14.2878 14.2766L22.8871 9.26668V16.6841Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const FrontRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group">
      <path
        id="Vector"
        d="M10.5898 14.4225C11.0202 14.5971 11.5028 14.6824 11.9935 14.6824V14.6702C11.5028 14.6702 11.0161 14.5849 10.5898 14.4225ZM1.6084 9.21777V9.22589L10.2077 14.2317L1.6084 9.21777Z"
        fill="white"
      />
      <path
        id="Vector_2"
        d="M23.0226 5.82796L13.7878 0.444557C12.7662 -0.148186 11.2298 -0.148186 10.2122 0.444557L0.973353 5.82796C0.353946 6.18929 0 6.73738 0 7.33418V16.6679C0 17.2647 0.353946 17.8168 0.973353 18.1781L10.2081 23.5575C10.7029 23.8498 11.3464 24 11.994 24H12.002C12.3399 24 12.6777 23.9594 12.9995 23.8782L13.5465 23.7361C13.5666 23.7239 13.5867 23.7158 13.6028 23.7077C13.6672 23.6752 13.7275 23.6427 13.7878 23.6103L23.0226 18.2268C23.642 17.8696 23.996 17.3174 23.996 16.7166V7.45192C24 7.41132 24 7.37478 24 7.33824C24 6.74144 23.642 6.18929 23.0226 5.82796ZM11.994 22.376C11.6239 22.376 11.2619 22.2989 11.0126 22.1528L1.77778 16.7693C1.67722 16.7125 1.62896 16.6597 1.60885 16.6354V9.2139L10.2081 14.2279C10.2725 14.2685 10.3369 14.3009 10.4052 14.3375C10.4656 14.3659 10.5259 14.3903 10.5862 14.4187C11.0126 14.5811 11.4992 14.6663 11.9899 14.6663V22.376H11.994ZM12.9834 12.8272C12.9231 12.8637 12.8547 12.8922 12.7863 12.9206C12.7823 12.9206 12.7783 12.9246 12.7743 12.9246C12.2393 13.1236 11.4671 13.0911 11.0166 12.8272L1.77778 7.4438C1.7094 7.4032 1.66516 7.36666 1.63701 7.33824C1.66516 7.30576 1.7094 7.27328 1.77376 7.23268L11.0126 1.85334C11.5274 1.55291 12.4646 1.55291 12.9794 1.85334L22.2142 7.23268C22.2866 7.27328 22.3308 7.30982 22.359 7.33824C22.3308 7.36666 22.2866 7.4032 22.2142 7.4438L12.9794 12.8272H12.9834Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const DefaultShapeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2475_5320)">
      <path
        d="M1.60889 9.21289V9.22101L10.2082 14.2273L1.60889 9.21289ZM10.5903 14.4181C11.0207 14.5927 11.5033 14.678 11.994 14.678V14.6658C11.5033 14.6658 11.0166 14.5805 10.5903 14.4181Z"
        fill="white"
      />
      <path
        d="M23.0226 5.8265L13.7878 0.442642C12.7662 -0.150151 11.2298 -0.150151 10.2122 0.442642L0.973354 5.8265C0.353947 6.18786 0 6.73599 0 7.33285V16.6673C0 17.2642 0.353947 17.8164 0.973354 18.1777L10.2081 23.5575C10.7029 23.8498 11.3464 24.0001 11.994 24.0001H12.002C12.3399 24.0001 12.6777 23.9595 12.9995 23.8783L13.5465 23.7362C13.5465 23.7362 13.5867 23.7159 13.6028 23.7077C13.6672 23.6753 13.7275 23.6428 13.7878 23.6103L23.0226 18.2264C23.642 17.8691 23.996 17.3169 23.996 16.716V7.45059C24 7.40999 24 7.37345 24 7.33691C24 6.74005 23.642 6.18786 23.0226 5.8265ZM11.994 22.376C11.6239 22.376 11.2619 22.2988 11.0126 22.1527L1.77778 16.7688C1.67722 16.712 1.62896 16.6592 1.60885 16.6348V9.21273L10.2081 14.2271H10.2122C10.2765 14.2677 10.3409 14.3002 10.4093 14.3367C10.4696 14.3652 10.5299 14.3895 10.5902 14.4179C11.0166 14.5803 11.5033 14.6656 11.994 14.6656V22.376ZM12.9834 12.8263C12.9231 12.8629 12.8547 12.8913 12.7863 12.9197C12.7823 12.9197 12.7783 12.9238 12.7743 12.9238C12.2393 13.1227 11.4671 13.0902 11.0166 12.8263L1.77778 7.44247C1.7094 7.40187 1.66516 7.36533 1.637 7.33691H1.64103C1.66918 7.30442 1.71342 7.27194 1.77778 7.23134L11.0166 1.85154C11.5314 1.55108 12.4686 1.55108 12.9834 1.85154L22.2182 7.23134C22.2906 7.27194 22.3348 7.30848 22.363 7.33691C22.3348 7.36533 22.2906 7.40187 22.2182 7.44247L12.9834 12.8263ZM22.3871 16.6835C22.371 16.712 22.3188 16.7607 22.2182 16.8216L13.6028 21.84V14.3733C13.6672 14.3449 13.7275 14.3124 13.7878 14.2758L22.3871 9.26551V16.6835Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2475_5320">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DoubleArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.3335 5.83333L3.3335 8.83333L8.00016 5.5L12.6668 8.83333L12.6668 5.83333L8.00016 2.5L3.3335 5.83333Z"
      fill="#DEDEDE"
    />
    <path
      d="M3.3335 10.5L3.3335 13.5L8.00016 10.1667L12.6668 13.5L12.6668 10.5L8.00016 7.16667L3.3335 10.5Z"
      fill="#DEDEDE"
    />
  </svg>
);

export const LeftArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="arrow_back">
      <path
        id="Vector"
        d="M12.5273 7.33667H5.08066L8.334 4.08333C8.594 3.82333 8.594 3.39667 8.334 3.13667C8.074 2.87667 7.654 2.87667 7.394 3.13667L3.00066 7.53C2.74066 7.79 2.74066 8.21 3.00066 8.47L7.394 12.8633C7.654 13.1233 8.074 13.1233 8.334 12.8633C8.594 12.6033 8.594 12.1833 8.334 11.9233L5.08066 8.67H12.5273C12.894 8.67 13.194 8.37 13.194 8.00333C13.194 7.63667 12.894 7.33667 12.5273 7.33667Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const RightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="arrow_back">
      <path
        id="Vector"
        d="M3.47267 8.66335H10.9193L7.666 11.9167C7.406 12.1767 7.406 12.6033 7.666 12.8633C7.926 13.1233 8.346 13.1233 8.606 12.8633L12.9993 8.47002C13.2593 8.21002 13.2593 7.79002 12.9993 7.53002L8.606 3.13668C8.346 2.87668 7.926 2.87668 7.666 3.13668C7.406 3.39668 7.406 3.81668 7.666 4.07668L10.9193 7.33002H3.47267C3.106 7.33002 2.806 7.63002 2.806 7.99668C2.806 8.36335 3.106 8.66335 3.47267 8.66335Z"
        fill="#757575"
      />
    </g>
  </svg>
);

export const PersonaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={15}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group">
      <path
        id="Vector"
        d="M7.57913 7.03208L8.75064 7.4532C10.6591 8.33372 12.0396 10.1932 12.2761 12.2824C12.3421 12.8785 12.3861 14.0708 12.3146 14.6505C12.2981 14.7981 12.2046 14.9403 12.0726 15.0005H0.280631C0.143131 14.9403 0.055131 14.7981 0.038631 14.6505C-0.032869 14.0762 0.011131 12.9004 0.077131 12.3152C0.346631 9.80489 2.28813 7.58992 4.77963 7.0649L3.97663 6.58909C1.98013 5.10151 2.03513 2.08259 4.08663 0.671574C6.13813 -0.739442 8.83864 0.179359 9.64714 2.44902C10.2961 4.27568 9.38864 6.31564 7.58464 7.02661L7.57913 7.03208ZM5.89063 0.830176C3.90513 1.02159 2.71163 3.18187 3.60813 4.95931C4.60363 6.93364 7.44164 7.0649 8.61314 5.17807C9.86714 3.15999 8.25014 0.605945 5.89063 0.830176ZM11.5116 14.2184C11.6051 12.5504 11.4181 11.0354 10.3511 9.70098C7.90364 6.64378 3.05813 7.18521 1.36413 10.7073C0.825131 11.8339 0.814131 12.9933 0.841631 14.2184H11.5061H11.5116Z"
        fill="#DEDEDE"
      />
      <path
        id="Vector_2"
        d="M11.9902 3.23682L17.7817 3.25322C18.0897 3.45011 18.0677 3.83294 17.7432 3.99701L12.1607 4.02983C11.6712 3.97514 11.5557 3.45011 11.9902 3.23682Z"
        fill="#DEDEDE"
      />
      <path
        id="Vector_3"
        d="M11.9903 5.50098H17.6663C18.1173 5.54473 18.1338 6.23383 17.5618 6.29399H12.1553C11.6658 6.2393 11.5503 5.71427 11.9848 5.50098H11.9903Z"
        fill="#DEDEDE"
      />
      <path
        id="Vector_4"
        d="M12.1 7.6665H15.422C15.9555 7.73213 15.8895 8.4103 15.4605 8.45952H12.056C11.5885 8.34467 11.6215 7.74307 12.1 7.6665Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const MenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#DEDEDE"
      d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1Zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1ZM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1Z"
    />
  </svg>
);

export const BreezeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Chat Avatars" clipPath="url(#clip0_5187_23233)">
      <path
        id="Vector"
        d="M24 14.289C24 19.1537 15.9113 23.9453 6.91236 23.9995C4.17755 24.0158 1.85767 23.6064 0.0282511 23.1674C-0.0142936 23.1574 -0.00664511 23.089 0.0368556 23.0895C0.656382 23.0958 1.27543 23.0285 1.88205 22.8869C7.36457 21.6085 13.5187 17.7258 13.7831 13.9421C13.8266 13.3227 13.5488 12.1037 12.7094 11.1448C14.1497 11.3974 15.7129 12.3911 16.2244 13.3832C17.3157 15.5069 15.9022 18.0079 13.3046 19.6727C9.96027 21.8158 6.24216 22.9295 2.89882 23.1479C11.8365 23.0437 19.8359 18.2779 19.8359 13.4406C19.8359 11.9569 18.8449 9.7516 16.2913 8.55318C21.9822 8.58686 24 12.1716 24 14.2885V14.289ZM5.98593 5.91896H5.93192C5.67952 8.66423 3.69665 10.8458 1.2042 11.1242V11.1837C3.69617 11.4616 5.67904 13.6437 5.93192 16.389H5.98593C6.23833 13.6437 8.21929 11.4621 10.7122 11.1837V11.1242C8.21881 10.8463 6.23833 8.66423 5.98593 5.91896ZM12.402 0H12.3576C12.1516 2.24264 10.5315 4.02527 8.49511 4.25264V4.30159C10.531 4.52843 12.1511 6.31159 12.3576 8.55423H12.402C12.6081 6.31159 14.2267 4.52896 16.2636 4.30159V4.25264C14.2267 4.0258 12.6086 2.24264 12.402 0Z"
        fill="#FFD51C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5187_23233">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuIcon2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="more_vert">
      <path
        id="Vector"
        d="M7.33341 11.0002C7.33341 9.99183 6.50841 9.16683 5.50008 9.16683C4.49175 9.16683 3.66675 9.99183 3.66675 11.0002C3.66675 12.0085 4.49175 12.8335 5.50008 12.8335C6.50841 12.8335 7.33341 12.0085 7.33341 11.0002ZM9.16675 11.0002C9.16675 12.0085 9.99175 12.8335 11.0001 12.8335C12.0084 12.8335 12.8334 12.0085 12.8334 11.0002C12.8334 9.99183 12.0084 9.16683 11.0001 9.16683C9.99175 9.16683 9.16675 9.99183 9.16675 11.0002ZM14.6667 11.0002C14.6667 12.0085 15.4917 12.8335 16.5001 12.8335C17.5084 12.8335 18.3334 12.0085 18.3334 11.0002C18.3334 9.99183 17.5084 9.16683 16.5001 9.16683C15.4917 9.16683 14.6667 9.99183 14.6667 11.0002Z"
        fill="#DEDEDE"
      />
    </g>
  </svg>
);

export const UnifiedModelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="view_timeline">
      <g id="Vector">
        <path d="M8 10.5H4V11.8333H8V10.5Z" fill="#DEDEDE" />
        <path d="M12 5.16667H8V6.5H12V5.16667Z" fill="#DEDEDE" />
        <path d="M10 7.83333H6V9.16667H10V7.83333Z" fill="#DEDEDE" />
        <path
          d="M12.6667 2.5H3.33333C2.6 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.6 14.5 3.33333 14.5H12.6667C13.4 14.5 14 13.9 14 13.1667V3.83333C14 3.1 13.4 2.5 12.6667 2.5ZM12.6667 13.1667H3.33333V3.83333H12.6667V13.1667Z"
          fill="#DEDEDE"
        />
      </g>
    </g>
  </svg>
);

export const Attachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="attach_file/Outlined">
      <path
        id="Vector"
        d="M13.3327 4.99967V14.583C13.3327 16.4247 11.841 17.9163 9.99935 17.9163C8.15768 17.9163 6.66602 16.4247 6.66602 14.583V4.16634C6.66602 3.01634 7.59935 2.08301 8.74935 2.08301C9.89935 2.08301 10.8327 3.01634 10.8327 4.16634V12.9163C10.8327 13.3747 10.4577 13.7497 9.99935 13.7497C9.54102 13.7497 9.16602 13.3747 9.16602 12.9163V4.99967H7.91602V12.9163C7.91602 14.0663 8.84935 14.9997 9.99935 14.9997C11.1493 14.9997 12.0827 14.0663 12.0827 12.9163V4.16634C12.0827 2.32467 10.591 0.833008 8.74935 0.833008C6.90768 0.833008 5.41602 2.32467 5.41602 4.16634V14.583C5.41602 17.1163 7.46602 19.1663 9.99935 19.1663C12.5327 19.1663 14.5827 17.1163 14.5827 14.583V4.99967H13.3327Z"
        fill="white"
      />
    </g>
  </svg>
);

export const SendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="send">
      <mask
        id="mask0_5249_23566"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <rect id="Bounding box" width={20} height={20} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5249_23566)">
        <path
          id="send_2"
          d="M2.5 16.6663V3.33301L18.3333 9.99967L2.5 16.6663ZM4.16667 14.1663L14.0417 9.99967L4.16667 5.83301V8.74967L9.16667 9.99967L4.16667 11.2497V14.1663Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);
